<template>
  <div style="padding: 20px; background: rgb(221, 225, 230); border: 1px solid rgb(204, 204, 204)">
    <!-- Mismo armado que ReposicionRules: el boton "Crear" lo renderiza el Modal, y para que el de
         importar quede en la misma linea van los dos dentro de un flex -->
    <div class="d-flex align-center">
      <Modal
        v-if="create_access"
        class="flex-grow-0"
        :button_name="'Crear ' + modal_title"
        :modal_title="modal_title"
        :page_title="page_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :service="service"
        @updateDialog="updateDialog"
        @loadList="loadList(service)"
        :editItem="mainItem"
      />

      <!-- Importar crea o actualiza: hace falta alta y modificacion (el backend pide las dos) -->
      <v-btn v-if="create_access && update_access" outlined class="ml-3 mb-3 btn-third" @click="dialog_import_excel = true">Importar Políticas</v-btn>

      <!-- Simulacion / aplicacion manual de las politicas (crons:aplicar_politicas_reposicion).
           Simular solo lee (permiso de listado); aplicar se habilita dentro del dialogo con alta + modificacion. -->
      <v-btn
        v-if="list_access"
        color="indigo"
        variant="outlined"
        :prepend-icon="politicas_running ? 'mdi-progress-clock' : 'mdi-calculator-variant-outline'"
        class="ml-auto mb-3"
        @click="dialog_politicas = true"
      >
        {{ politicas_running ? "Procesando políticas..." : "Simular / Aplicar políticas" }}
      </v-btn>
    </div>

    <!-- Aplicar crea/modifica reglas, no politicas: no hace falta recargar este listado -->
    <ModalSimularPoliticas
      v-if="list_access"
      :dialog="dialog_politicas"
      :almacenes="almacenes"
      :almacen_default="filters.almacen"
      :can_simulate="list_access"
      :can_apply="create_access && update_access"
      @close="dialog_politicas = false"
      @running="politicas_running = $event"
    />

    <ModalImportExcelPoliticas
      v-if="create_access && update_access"
      modal_title="Importar Políticas de Reposición"
      formBtn="Importar"
      :dialog="dialog_import_excel"
      :service="service"
      @updateDialog="dialog_import_excel = $event"
      @loadList="loadList(service)"
    />

    <div class="mb-2">
      <span class="text-caption text-grey-darken-1">
        <v-icon size="small" class="mr-1">mdi-clock-outline</v-icon>
        Las políticas activas se aplican automáticamente una vez por mes. Para simularlas o aplicarlas a mano use "Simular / Aplicar políticas".
      </span>
    </div>

    <!-- Filtros -->
    <v-card class="mb-4" v-if="list_access">
      <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
        <div class="col-md-12">
          <div class="col-md-12" style="background: white">
            <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
            <v-divider class="mt-0"></v-divider>

            <div class="row pt-2">
              <div class="col-md-3">
                <v-combobox v-model="filters.almacen" density="comfortable" item-title="name" item-value="id" :items="almacenes" label="Almacén" autocomplete="off" clearable></v-combobox>
              </div>
              <div class="col-md-3">
                <v-combobox v-model="filters.client" density="comfortable" item-title="name" item-value="id" :items="clientes_filtro" label="Cliente" autocomplete="off" clearable></v-combobox>
              </div>
              <div class="col-md-3">
                <v-combobox v-model="filters.category" density="comfortable" item-title="name" item-value="id" :items="categories" label="Rubro" autocomplete="off" clearable></v-combobox>
              </div>
              <div class="col-md-3">
                <v-combobox
                  v-model="filters.tipo_ubicacion"
                  density="comfortable"
                  :item-title="tipoUbicacionLabel"
                  item-value="id"
                  :items="tipos_ubicacion_filtro"
                  label="Tipo de ubicación"
                  autocomplete="off"
                  clearable
                ></v-combobox>
              </div>
              <div class="col-md-3">
                <v-select v-model="filters.activo" density="comfortable" item-title="name" item-value="id" :items="estados" label="Estado" clearable></v-select>
              </div>

              <div class="col-md-9 pt-2" style="display: flex; justify-content: end">
                <v-btn color="info" @click="loadList(service)" prepend-icon="mdi-magnify">Buscar</v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-card>

    <!-- Tabla -->
    <v-card v-if="list_access">
      <v-card-title>
        <v-row align="center" class="mt-1">
          <v-col>
            <span>{{ page_title }}</span>
            <v-tooltip location="top">
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props" variant="text" size="small" icon class="ml-2" aria-label="Cómo funcionan las políticas" @click="dialog_info = true">
                  <v-icon color="grey">mdi-information-outline</v-icon>
                </v-btn>
              </template>
              <span>Cómo funcionan las políticas</span>
            </v-tooltip>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="3">
            <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
          </v-col>
        </v-row>
      </v-card-title>

      <v-data-table :headers="headers" :items="list" :search="search" :loading="loading" loading-text="Cargando...">
        <template v-slot:item="{ item }">
          <tr>
            <td class="text-no-wrap">#{{ item.id }}</td>
            <td>{{ item.almacen ? item.almacen.name : "-" }}</td>
            <td>{{ item.client ? item.client.name : "Todos" }}</td>
            <td>
              {{ item.category ? item.category.name : "-" }}
              <span class="text-caption text-grey-600 d-block">Subrubro: {{ item.subcategory ? item.subcategory.name : "Todos" }}</span>
            </td>
            <td>{{ item.tipo_ubicacion ? item.tipo_ubicacion.name : "-" }}</td>
            <td class="text-center">{{ formatNumber(item.min_days) }} / {{ formatNumber(item.max_days) }}</td>
            <td class="text-center">{{ item.back_period_days }}</td>
            <td>
              <v-tooltip v-if="item.observacion" location="top" max-width="400">
                <template v-slot:activator="{ props }">
                  <v-chip v-bind="props" color="warning" size="small" variant="tonal">
                    <v-icon start size="small">mdi-alert</v-icon>
                    Sin medidas
                  </v-chip>
                </template>
                <span>{{ item.observacion }}</span>
              </v-tooltip>
            </td>
            <td>
              <v-chip :color="item.activo ? 'green' : 'red'" size="small">
                {{ item.activo ? "Activa" : "Inactiva" }}
              </v-chip>
            </td>
            <td class="text-center" style="width: 110px; min-width: 110px; white-space: nowrap">
              <v-tooltip bottom>
                <template v-slot:activator="{ props }">
                  <v-icon v-if="update_access" v-bind="props" small color="blue" class="mr-2" v-on:click="editItem(item)" size="small"> mdi-pencil</v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" small color="blue" class="mr-2" v-on:click="viewItem(item)" size="small"> mdi-eye </v-icon>
                </template>
                <span>Ver</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ props }">
                  <v-icon v-if="delete_access" v-bind="props" small color="red" class="mr-2" v-on:click="deleteItem(item)" size="small">mdi-delete </v-icon>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" :loading="loadingSubmit" />

    <DialogInfo :dialog="dialog_info" title="Cómo funcionan las políticas de reposición" @updateDialog="dialog_info = $event">
      <div class="pt-4">
        <p class="text-h6 mb-1">¿Qué hace una política?</p>
        <v-divider class="mb-3"></v-divider>
        <p class="text-body-2 mb-2">
          Calcula sola el mínimo, el máximo y las ubicaciones de picking de las reglas de reposición de los productos de un rubro (o subrubro) en un almacén, a partir de lo que realmente se despachó.
        </p>
        <p class="text-body-2 mb-2">
          <b>Cuándo se aplica:</b> automáticamente el día 1 de cada mes a las 00:45, al dar de alta un producto o importarlo por Excel, y a mano con el botón "Simular / Aplicar políticas" de esta pantalla. Conviene simular antes de aplicar.
        </p>
        <p class="text-body-2 mb-4">
          <b>El mínimo y el máximo son totales de la regla:</b> si la regla tiene 3 ubicaciones, se compara la suma del stock de las 3 contra el mínimo, y se repone hasta el máximo repartiendo entre ellas.
        </p>

        <p class="text-h6 mb-1">¿Qué política le toca a cada producto?</p>
        <v-divider class="mb-3"></v-divider>
        <p class="text-body-2 mb-4">
          Si a un producto le aplican varias, gana la más específica: primero la de su subrubro sobre la de todo el rubro, y después la de su cliente sobre la de todos los clientes. Las inactivas no cuentan.
        </p>

        <p class="text-h6 mb-1">Cálculo del mínimo y el máximo</p>
        <v-divider class="mb-3"></v-divider>
        <div class="text-body-2 mb-4">
          <div class="mb-2">
            <span class="font-weight-bold">Demanda diaria</span> —
            <span class="text-grey-600">unidades despachadas del producto en el almacén durante la ventana (por defecto 180 días), divididas por los días en que el almacén despachó algo. No se usan días corridos: los fines de semana y feriados harían parecer la demanda más baja de lo que es.</span>
          </div>
          <div class="mb-2">
            <span class="font-weight-bold">Mínimo y máximo</span> —
            <span class="text-grey-600">demanda diaria × días de cobertura del mínimo y del máximo, redondeados hacia arriba a un número entero. Si la política tiene activado "Redondear a caja" (por defecto no) y el producto tiene caja, se redondean además hacia arriba a cajas completas (ej: 2,1 u./día × 2 días = 5 u.; con caja de 12 queda en 12). El máximo siempre queda mayor que el mínimo.</span>
          </div>
          <div class="mb-2">
            <span class="font-weight-bold">Producto sin despachos</span> —
            <span class="text-grey-600">se usan el mínimo y el máximo por defecto de la política, y la regla queda con la observación "sin historia". En la corrida del mes siguiente ya toma la demanda real.</span>
          </div>
          <div class="mb-2">
            <span class="font-weight-bold">Umbral de cambio</span> —
            <span class="text-grey-600">para que las reglas no cambien todos los meses por ruido, una regla existente solo se actualiza si el mínimo o el máximo cambian más que ese porcentaje (por defecto 15%).</span>
          </div>
        </div>

        <p class="text-h6 mb-1">Ubicaciones y capacidad</p>
        <v-divider class="mb-3"></v-divider>
        <p class="text-body-2 mb-2">
          Cuántas unidades entran en una ubicación se calcula con el volumen del tipo de ubicación (alto × largo × ancho) por el factor de llenado (por defecto 0,85, porque las cajas nunca ocupan el 100% del hueco), dividido el volumen de una unidad del producto. Se agregan ubicaciones del tipo de la política hasta que entre el máximo.
        </p>
        <p class="text-body-2 mb-2">
          Se eligen primero las que ya están en la regla, después las que ya tienen stock del producto y por último las libres, en orden de zona, rack, columna y nivel para que queden juntas. No se usan las bloqueadas, en cuarentena o en conteo, ni las de la regla de otro producto (salvo que la ubicación admita varios productos).
        </p>
        <p class="text-body-2 mb-4">
          <b>Para no mover mercadería de más:</b> las ubicaciones actuales se conservan mientras sigan siendo válidas, solo se agregan cuando la capacidad no alcanza, y solo se quitan si están vacías y sin tareas de reposición pendientes.
        </p>

        <p class="text-h6 mb-1">Casos especiales</p>
        <v-divider class="mb-3"></v-divider>
        <div class="text-body-2 mb-4">
          <v-alert type="warning" variant="tonal" density="compact" class="mb-3">
            <b>Tipo de ubicación sin medidas</b> (chip "Sin medidas" en esta tabla): si al tipo de ubicación de la política le falta el alto, el largo o el ancho, no se puede calcular la capacidad. Las reglas se crean igual, pero con <b>una sola ubicación</b> y <b>sin topear el máximo</b>, aunque físicamente no entre. Las reglas quedan con la observación "tipo de ubicacion sin medidas". Se soluciona cargando las medidas en Tipos de ubicación; no hace falta volver a guardar la política.
          </v-alert>
          <v-alert type="warning" variant="tonal" density="compact" class="mb-3">
            <b>Producto sin medidas:</b> pasa lo mismo que con el tipo sin medidas: una sola ubicación, máximo sin topear y la observación "sin volumen" en la regla. Se soluciona cargando las medidas del producto.
          </v-alert>
          <v-alert type="warning" variant="tonal" density="compact" class="mb-3">
            <b>Capacidad insuficiente:</b> si ni con todas las ubicaciones disponibles del tipo entra el máximo, el máximo se baja a lo que entra y el mínimo se achica en la misma proporción. La regla queda con la observación "capacidad insuficiente". El producto no se queda sin regla.
          </v-alert>
          <v-alert type="error" variant="tonal" density="compact" class="mb-3">
            <b>Sin ubicaciones disponibles:</b> si no hay ninguna ubicación libre del tipo en el almacén, no se puede crear la regla. Aparece como error en la simulación y queda registrado en el historial.
          </v-alert>
        </div>

        <p class="text-h6 mb-1">Productos y reglas que la política no toca</p>
        <v-divider class="mb-3"></v-divider>
        <div class="text-body-2">
          <div class="mb-2">
            <span class="font-weight-bold">Reglas manuales</span> —
            <span class="text-grey-600">las cargadas a mano o por Excel. Si editás a mano una regla de una política, pasa a ser manual y la política ya no la toca, salvo que marques "Mantener gestionada por la política".</span>
          </div>
          <div class="mb-2">
            <span class="font-weight-bold">Productos excluidos</span> —
            <span class="text-grey-600">los que tienen marcado "Excluir de políticas de reposición" en su ficha.</span>
          </div>
          <div class="mb-2">
            <span class="font-weight-bold">Otros</span> —
            <span class="text-grey-600">productos discontinuados, incompletos (sin presentaciones) y combos.</span>
          </div>
        </div>
      </div>
    </DialogInfo>
  </div>
</template>

<script>
import { politicaReposicionService } from "@/libs/ws/politicaReposicionService";
import { almacenService } from "@/libs/ws/almacenService";
import { rubroService } from "@/libs/ws/rubroService";
import { clientService } from "@/libs/ws/clientService";
import { tipoUbicacionService } from "@/libs/ws/tipoUbicacionService";
import Constant from "@/constants/sections";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import Modal from "./PoliticaReposicionModal.vue";
import ModalImportExcelPoliticas from "./ModalImportExcelPoliticas.vue";
import ModalSimularPoliticas from "./ModalSimularPoliticas.vue";

export default {
  components: { Modal, ModalImportExcelPoliticas, ModalSimularPoliticas },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      rol_section: Constant.SECTION_RULES,
      service: politicaReposicionService,
      page_title: "Políticas de Reposición",
      modal_title: "Política de Reposición",
      dialog_info: false,
      dialog_import_excel: false,
      dialog_politicas: false,
      politicas_running: false, //lo informa ModalSimularPoliticas mientras sigue el proceso
      almacenes: [],
      categories: [],
      clients: [],
      tipos_ubicacion: [],
      estados: [
        { id: 1, name: "Activas" },
        { id: 0, name: "Inactivas" },
      ],
      filters: {
        almacen: null,
        client: null,
        category: null,
        tipo_ubicacion: null,
        activo: null,
      },
      headers: [
        //Mismo numero que citan los mensajes de la simulacion y del historial ("Politica #1")
        { title: "Nº", align: "left", sortable: true, key: "id", width: "70px" },
        { title: "Almacén", align: "left", sortable: true, key: "almacen.name" },
        { title: "Cliente", align: "left", sortable: true, key: "client.name" },
        { title: "Rubro / Subrubro", align: "left", sortable: true, key: "category.name" },
        { title: "Tipo de ubicación", align: "left", sortable: true, key: "tipo_ubicacion.name" },
        { title: "Cobertura mín / máx (días)", align: "center", sortable: false, key: "min_days" },
        { title: "Ventana (días)", align: "center", sortable: true, key: "back_period_days" },
        { title: "Observación", align: "left", sortable: true, key: "observacion" },
        { title: "Estado", align: "left", sortable: true, key: "activo" },
        { title: "Accion", align: "center", sortable: false, key: "", width: "110px" },
      ],
    };
  },
  computed: {
    //id 0 = politicas generales (sin cliente). El backend lo recibe en filtro_client.
    clientes_filtro() {
      return [{ id: 0, name: "Todos los clientes (generales)" }].concat(this.clients);
    },
    //Los tipos de ubicacion son por sucursal: con un almacen elegido solo se ofrecen los suyos
    tipos_ubicacion_filtro() {
      const almacen = this.filters.almacen;
      if (almacen && almacen.sucursal && almacen.sucursal.id) {
        return this.tipos_ubicacion.filter((t) => t.sucursal && t.sucursal.id == almacen.sucursal.id);
      }
      return this.tipos_ubicacion;
    },
  },
  watch: {
    "filters.almacen"() {
      //El tipo elegido puede no ser de la sucursal del nuevo almacen
      const tipo = this.filters.tipo_ubicacion;
      if (tipo && tipo.id && !this.tipos_ubicacion_filtro.some((t) => t.id == tipo.id)) {
        this.filters.tipo_ubicacion = null;
      }
    },
  },
  mounted() {
    //Almacen por defecto del usuario (lo guarda el login), como en el resto de las pantallas.
    //Antes de loadList para que la primera carga ya venga filtrada.
    this.filters.almacen = JSON.parse(localStorage.getItem("almacen"));
    this.loadAlmacenes();
    this.loadClients();
    this.loadCategories();
    this.loadTiposUbicacion();
    this.loadList(this.service);
  },
  methods: {
    getFilterParams() {
      var param = {};
      if (this.filters.almacen && this.filters.almacen.id) param.almacen = { id: this.filters.almacen.id };
      if (this.filters.client && this.filters.client.id !== undefined && this.filters.client.id !== null) param.filtro_client = { id: this.filters.client.id };
      if (this.filters.category && this.filters.category.id) param.category = { id: this.filters.category.id };
      if (this.filters.tipo_ubicacion && this.filters.tipo_ubicacion.id) param.tipo_ubicacion = { id: this.filters.tipo_ubicacion.id };
      if (this.filters.activo !== null && this.filters.activo !== undefined) param.activo = this.filters.activo;
      // La tabla pagina del lado del cliente: se pide el listado completo
      param.limit = 0;
      return param;
    },
    formatNumber(value) {
      if (value === null || value === undefined || value === "") return "-";
      return parseFloat(value).toLocaleString("es-AR", { maximumFractionDigits: 2 });
    },
    loadAlmacenes() {
      almacenService.filter({}).then((response) => {
        this.almacenes = response.result.list;
      });
    },
    loadClients() {
      clientService
        .filter({})
        .then((response) => {
          this.clients = response.result.list;
        })
        .catch((e) => {
          console.log("clientService.filter error", e);
        });
    },
    loadTiposUbicacion() {
      //Solo los de picking: son los unicos que puede tener una politica
      tipoUbicacionService
        .filter({})
        .then((response) => {
          this.tipos_ubicacion = response.result.list.filter((t) => t.allow_picking);
        })
        .catch((e) => {
          console.log("tipoUbicacionService.filter error", e);
        });
    },
    //El nombre se puede repetir entre sucursales: se agrega la sucursal para distinguirlos
    tipoUbicacionLabel(tipo) {
      if (tipo == null || typeof tipo !== "object") return tipo;
      return tipo.sucursal && tipo.sucursal.name ? tipo.name + " (" + tipo.sucursal.name + ")" : tipo.name;
    },
    loadCategories() {
      rubroService
        .filter({})
        .then((response) => {
          this.categories = response.result.list;
        })
        .catch((e) => {
          console.log("rubroService.filter error", e);
        });
    },
  },
};
</script>
